/* eslint-disable no-undef */
import { call, put, takeEvery } from "redux-saga/effects"

// Login Redux States
import { LIST_QUIZZ } from "./actionTypes"
import { apiError, listQuizzSuccess } from "./actions"

//Include Both Helper File with needed methods
import { getQuizzes, getQuizzesNewApi } from "../../../helpers/backend_helper"

function* list(request) {
  try {
    const response = yield call(getQuizzesNewApi, {
      lessonId: request.payload.lessonId,
      userId: request.payload.userId,
    })
    if (response == undefined) throw new Error("API error")
    yield put(listQuizzSuccess(response))
  } catch (error) {
    console.log(error.message)
    yield put(apiError(error.message))
  }
}

function* quizzListSaga() {
  yield takeEvery(LIST_QUIZZ, list)
}

export default quizzListSaga
